export const formFieldNames = {
	orderNumber: 'orderNumber',
	orderDate: 'orderDate',
	note: 'note',
	nameKz: 'nameKz',
	nameRu: 'nameRu',
}
